/*
 * @Description:
 * @Author:  Teemo Ding
 * @Date: 2021-04-14 15:10:57
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-04-29 17:10:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductContent/index.tsx
 */

import React from 'react';

import { ModuleCart } from '@/src/constrains';
import { EnumModuleType } from '@/src/types/common/module';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Skeleton } from 'src/components/Antd';
import { useSalesChannelProductLinkSet } from 'src/components/LinkModule/hooks';
import ContentGroup from 'src/constrains/DraggableModules/ContentGroup';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/BasicPageHOC';
import RouteBlock from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/RouteBlock';
import { dispatch } from 'src/store';
import { NULL } from 'src/tools/constant';
import { ChannelType } from 'src/types/common/SalesChannel';
import { ActionType } from 'src/types/common/common';
import { DEFAULT_MULTI_LANGUAGE_PARAMS } from '@/src/types/server/params';
import TranslationTip from 'src/constrains/SalesChannelAITranslation/TranslationTip';
import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper2';
import RightConfigWrapper from '../../../constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import Carousel from './Carousel';
import CloneBtn from './CloneButton';
import ContentDetails from './ContentDetails';
import MiniProgramInfo from './MiniInfo';
import MiniProgramShare from './MiniShare';
import Preview from './Preview';
import ReviewKeywords from './ReviewKeywords';
import SEOSetting from './SEOSetting';
import ThumbnailImage from './ThumbnailImage';
import OptionsImage from './OptionsImage';
import {
  ProductType,
  generateLongCanvas,
  generatePoster,
  generateText,
  generateVideo,
} from './common';
import { productIdHooks } from './hooks/productIdHooks';
import { convertDataFromReduxToServer } from './tools';

import {
  getCollapseOpenStatus,
  getCollapseStatus,
  getCollapseValidationMsgDisplay,
  getContent,
  getH1TagUuid,
  getHasModified,
  getLoaded,
  getModulesContent,
  getOpeningCollapse,
  getOrder,
  getProductUuid,
  getSalesChannel,
  getSalesChannelName,
  getState,
  getVisibleCollapse,
  initProductContent,
  initializeEmpty,
  moduleContentDynamicOnChange,
  moduleContentOnChange,
  moduleContentStaticOnChange,
  onCollapseOpen,
  onDuplicate,
  onErrorChange,
  onModuleTypeChange,
  submitContent,
  validation,
  translateProductContent,
  endInit,
} from './slice';

import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from 'src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from './style.module.less';

const permissions = (saleChannelUuid) => {
  const canViewDetails = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.view_product_details_page,
      }),
    ],
  });
  const canCreate = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.add_edit_product,
      }),
    ],
  });
  return { canViewDetails, canCreate };
};

const SalesChannelProductContent = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const {
    onDiscard,
    submitData,
    hasModified,
    salesChannelName,
    isOnPrimaryLanguage,
    loaded: _loaded,
  } = props;

  const order = useSelector(getOrder());
  const h1TagUuid = useSelector(getH1TagUuid());
  const loaded = useSelector(getContent('loaded'));

  const contentData = useSelector(getContent('contentDetails'));
  const productType = useSelector(getContent('productType'));
  const reviewDisplayed = useSelector(getContent('reviewDisplayed'));
  const translationEnabled = useSelector(getContent('translationEnabled'));
  const translationLoading = useSelector(getContent('translationLoading'));

  const productContentUuid = useSelector(getContent('productContentUuid'));

  const _d = useDispatch();
  const history = useHistory();
  const type = useSalesChannelType();

  const _params: {
    salesChannelProductUuid: string;
    saleChannelUuid: string;
  } = useParams();
  const { saleChannelUuid } = _params;
  const multiLanguageParams = DEFAULT_MULTI_LANGUAGE_PARAMS;
  const linkSet = useSalesChannelProductLinkSet({
    salesChannelUuid: saleChannelUuid,
  });
  React.useEffect(() => {
    if (_loaded) {
      _d(endInit());
    }
  }, [_loaded, _d]);
  productIdHooks(getProductUuid);

  const onGoBack = () => {
    history.push(`/salesChannel/products/${saleChannelUuid}`);
  };

  const handleOnCollapseOpen = (idArr) => {
    _d(onCollapseOpen({ idArr }));
  };

  const handleOnModuleTypeChange = (data) => {
    _d(onModuleTypeChange(data));
  };

  const handleOnModuleOrderListChange = (obj) => {
    _d(moduleContentOnChange(obj));
  };

  const handleOnModuleContentDynamicChange = (obj) => {
    _d(moduleContentDynamicOnChange(obj));
  };

  const handleOnModuleContentStaticChange = (obj) => {
    _d(moduleContentStaticOnChange(obj));
  };
  const handleOnDuplicate = (data) => {
    _d(onDuplicate(data));
  };
  const handleOnTranslate = (translationEnabled) => {
    _d(
      translateProductContent({
        uuid: productContentUuid,
        translationEnabled,
        multiLanguageParams,
      }),
    );
  };
  const moduleList = () => {
    return [
      {
        type: EnumModuleType.Poster,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generatePoster(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.LongCanvas,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateLongCanvas(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.Text,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateText(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.Video,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateVideo(),
            }),
          );
        },
      },
    ];
  };

  const isMulti =
    productType == ProductType.MultiplePhysical ||
    productType == ProductType.MultipleVirtual;

  const { canViewDetails, canCreate } = permissions(saleChannelUuid);
  const hideEdit = !canCreate;
  const child =
    // !aliasUuid?
    [
      {
        body: (
          <div>
            {!isOnPrimaryLanguage && canCreate && (
              <CloneBtn disabled={translationEnabled} />
            )}
            <ContentDetails
              isOnPrimaryLanguage={isOnPrimaryLanguage}
              disabled={!canCreate || translationEnabled}
              isMulti={isMulti}
            />
            <Carousel
              isOnPrimaryLanguage={isOnPrimaryLanguage}
              disabled={!canCreate || translationEnabled}
              hideEdit={hideEdit}
            />
            {(productType == ProductType.MultiplePhysical ||
              productType == ProductType.MultipleVirtual) && (
              <>
                <ThumbnailImage
                  isOnPrimaryLanguage={isOnPrimaryLanguage}
                  disabled={!canCreate || translationEnabled}
                  hideEdit={hideEdit}
                />
                {type !== ChannelType.MiniProgram && (
                  <OptionsImage
                    isOnPrimaryLanguage={isOnPrimaryLanguage}
                    disabled={!canCreate || translationEnabled}
                    hideEdit={hideEdit}
                  />
                )}
              </>
            )}
            {type !== ChannelType.MiniProgram && (
              <SEOSetting
                isOnPrimaryLanguage={isOnPrimaryLanguage}
                disabled={!canCreate || translationEnabled}
              />
            )}
            {reviewDisplayed && (
              <ReviewKeywords disabled={!canCreate || translationEnabled} />
            )}
            {type == ChannelType.MiniProgram && (
              <MiniProgramShare
                disabled={!canCreate || translationEnabled}
                hideEdit={hideEdit}
              />
            )}
            {type == ChannelType.MiniProgram && <MiniProgramInfo />}
          </div>
        ),
        key: 'TopConfig',
      },
      {
        key: 'moduleContent',
        body: (
          <ContentGroup
            getCollapseOpenStatus={getCollapseOpenStatus}
            onCollapseOpen={handleOnCollapseOpen}
            getOpeningCollapse={getOpeningCollapse}
            getContent={getModulesContent}
            droppableId={'SalesChannelProductContent'}
            data={order}
            onModuleTypeChange={handleOnModuleTypeChange}
            onOrderListOnChange={handleOnModuleOrderListChange}
            onDynamicChange={handleOnModuleContentDynamicChange}
            onStaticChange={handleOnModuleContentStaticChange}
            linkSet={linkSet}
            getErrorDisplay={getCollapseValidationMsgDisplay}
            onErrorChange={onErrorChange}
            getVisibleCollapse={getVisibleCollapse}
            getCollapseStatus={getCollapseStatus}
            extraProps={{ h1TagUuid: h1TagUuid }}
            disabled={!canCreate}
            allDisabled={translationEnabled}
            onDuplicate={handleOnDuplicate}
            hideEdit={hideEdit}
          />
        ),
      },
    ];

  return (
    <Skeleton loading={!loaded} className={styles.container}>
      <div className={styles.container}>
        <React.Fragment>
          <RouteBlock getHasModified={getHasModified} />
          <PageWrapper
            avoidSubmitWhenHasError
            headerConfig={{
              description: canViewDetails && contentData.productName,
              topTitle: salesChannelName,
              hasModified,
              submit: canCreate && submitData,
              onDiscard,
              onGoBack,
              translationEnabled,
              handleOnTranslate,
              translationLoading,
            }}
            leftChild={
              canViewDetails ? (
                <div className={styles.left}>
                  <div className={styles.moduleCart}>
                    {loaded && canCreate && !translationEnabled && (
                      <ModuleCart
                        moduleList={moduleList()}
                        disabled={translationEnabled}
                      />
                    )}
                  </div>
                  {translationEnabled && !isOnPrimaryLanguage && (
                    <div className={styles.translationTip}>
                      <TranslationTip />
                    </div>
                  )}
                  <Preview
                    order={order}
                    getModulesContent={getModulesContent}
                    getCollapseStatus={getCollapseStatus}
                    translationEnabled={translationEnabled}
                  />
                </div>
              ) : (
                <div className={styles.content}>
                  {getI18n('general.permission.permissiondenied')}
                </div>
              )
            }
            rightChild={
              loaded && canViewDetails ? (
                <RightConfigWrapper
                  title={getI18n('general.sider.content')}
                  elements={child}
                />
              ) : null
            }
          />
        </React.Fragment>
      </div>
    </Skeleton>
  );
};
export default BasicPageHOC(SalesChannelProductContent, {
  getState,
  convertDataFromReduxToServer,
  submit: submitContent,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  validation,
  getLoaded,
  queryData: (params, qParams) => {
    const { salesChannelProductUuid, saleChannelUuid } = params;
    if (salesChannelProductUuid !== NULL) {
      dispatch(
        initProductContent({
          body: salesChannelProductUuid,
          params: qParams,
        }),
      );
    } else {
      dispatch(initializeEmpty(saleChannelUuid));
    }
  },
});
